import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth63: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M13.6,114.4l-5.8-11.1v-11.8l4.8-9.7s78.2-20.3,176.1,0l3.3,13.2v10l-4.3,9.3s-81.7-22.3-174.1,0Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M58,69.2h79.3S65.4-.2,58,69.2Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.7,62.3l-14,19.6-4.8,9.7v11.8l5.8,11.1,10.3,13.3s65.3-32.1,2.7-65.4Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M180.2,62.3l8.5,19.6,3.3,13.2v10l-4.3,9.3-11.5,17.1s-69.4-56.1,4-69.2Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M7.9,95v-3.4l18.8-29.3,8.7-8.6,9.2-5.5,6.3-4,12.1-9.7,10.3-5.9,8.3-1.3h6.5l7.4.9,20.5,3.8,33,7.2,15.7,5.6,9.2,7.2,6.5,10.3,6.3,10.5,3.8,15.6,1.6,6.7s-102.2-19.6-184.2,0Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M7.9,95v8.2l5.1,11,11.9,16,13.2,13.5,16.9,13.3,18.2,11.7,16.2,8.7,12.6,5.4,13,.9,14.1-2.7,14.4-7.9,9.4-9.9,10.1-11.4,9-12.5,12.3-19.1,5.6-9.6,2.2-6.5v-9.2s-101-19.4-184.2,0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M109.6,183.4c-15.9-.6-32.3-12.8-46.1-21.9-22.8-14.9-35-25.6-50.4-48.6-4.2-6.3-7-14.8-4-22.1,5-12,12.4-23,21.5-32.2s14.9-9.6,22-15,11.7-10.6,19.5-13.5,13.8-2.9,20.9-1.5l59.2,12.1c12.6,2.6,21.9,10.1,27.7,21.3,4.6,9.1,9.1,17.8,10.8,28.1,1.1,6.9,1.9,14.7-1.7,20.9-6.5,11.4-14.2,21.6-21.3,32.5s-9.4,11.7-14.2,17.8c-10.6,13.6-25.5,22.6-43.9,21.9Z',
			},
		},
	},
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '60.1 44.7 176.8 44.7 170 37.5 154 29.5 143.6 25.5 115.4 9.1 105.9 9.1 103.5 10 60.1 44.7',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M24.8,106.6v-26.3l5.4-12.2,13-10.8s63.5,37.8-18.4,49.4h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M186.5,56l4.1,6.7,2.4,8,.8,8.8v8.8l-5.4,11.4-4.2,8.3s-73.8-29.4,2.3-51.8v-.2Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M92.1,102.1A14.9,14.9 0 0 1 121.9,102.1A14.9,14.9 0 0 1 92.1,102.1Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.1,113s71.7,45.8,155.4-1.1l-9.7,14.6s-57.8,44.4-138.6.8l-7.1-14.4h0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.1,113l-1.3-6.4v-26.3l5.4-12.2,13-10.8,16.9-12.5,24.1-19.2s22.8,102.4-58,87.6v-.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M181.6,111.9l2.7-4.1,9.6-19.7-.8-17.6-2.4-8-4.1-6.7-9.8-11.4-6.8-7.2-27.9-11.9s-29.3,101.3,39.5,86.4v.2Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.1,113l-1.3-6.4v-26.3l5.4-12.2,13-10.8,16.9-12.5,24.1-19.2,19.3-15.4,2.4-1h9.4l28.3,16.4,26.3,12,16.6,18.5,4.1,6.7,2.4,8,.8,17.6-12.3,23.7s-72.2,46.9-155.4,1.1v-.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M183.5,108.6c-49.9,45.4-108.7,45.8-158.1-1.1-.8-16-2.2-31.5,9.4-42.8,16.5-16.5,35.6-24.5,52.3-40.6,4.3-4.1,9-7.8,13.6-11.4s13.1-4.5,19.5-.8l25.3,14.5c9.7,5.6,25.7,5.8,41.6,30.3,7.4,11.5,7.8,25.9,3.2,38.6l-6.8,13.2Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '44.3 462.6 167 462.6 159.3 471.8 131.6 489.1 114.6 498.5 105.6 501.3 99.9 501.3 92.4 497.6 44.3 462.6',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.8,452.3l-10.8-16-1.3-24.8,10.1-23.8s58.4,32.3,2,64.6Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M165.4,387.7l9.4,13.2,3.9,9.4v23.3l-7.4,18.6s-65.1-29.2-5.9-64.6Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M72.2,427.3h55.3s-30.1-118.9-55.3,0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.9,387.7s57.1-42.2,134.5,0l-3.7-14.5s-63.6-32.6-122.6-1.6l-8.2,16.1Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.9,387.7l-10.1,23.8,1.3,24.8,10.8,16,11.4,10.3,33.7,24.5s-3.8-88.3-47.1-99.3Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M165.4,387.7l9.4,13.2,3.9,9.4v23.3l-5.5,18.6-6.1,10.3-7.7,9.2-27.8,17.3s-12.9-92.3,33.8-101.3Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.9,387.7l-10.1,23.8,1.3,24.8,10.8,16,11.4,10.3,48.2,35.1,7.4,3.6h5.8l9-2.8,17-9.4,27.8-17.3,7.7-9.2,6.2-10.3,5.4-18.6,1.8-16.3-1.8-9-13.3-20.6s-67.4-41.8-134.5,0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M121.4,494.3c-10.8,6.3-19.6,9.4-28.9,2.1l-25.1-19.7c-12.1-7.7-24.4-14.3-34.2-24.9-13.5-11.9-12.9-26-10.9-43.7,17.5-13.4,36-24.5,56.6-32.2,43.9-16.3,80.8-6.6,100.1,37.1,0,24.8-3.2,40.5-20.5,58.3-4.9,5.1-11.5,7.8-17.5,11.4l-19.6,11.5Z',
			},
		},
	},
};
